<template>
  <aw-shortlist-page />
</template>

<script setup lang="ts">
  import AwShortlistPage from '~~/common/components/Page/ProductList/AwShortlistPage.vue';

  defineOptions({
    name: 'ShortlistPageShop',
  });

  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'dynamic-content',
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
</style>
